var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/forgot-password/signin-signup.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"forgotPassword")),"showPasswordResetSent")) {
output += "\n\n<div class=\"c-modal-login__navigation\">\n\n    <a href=\"";
output += runtime.suppressValue((lineno = 6, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "loginUrl"), "loginUrl", context, [])), env.opts.autoescape);
output += "\" rel=\"nofollow\" data-cm-element=\"account_login_modal\" data-qa-password-reset-signin class=\"c-modal-login__a c-modal-login__a--first js-user-login\">\n        ";
output += runtime.suppressValue((lineno = 7, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_sign-in",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n\n    <a href=\"";
output += runtime.suppressValue((lineno = 10, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "signUpUrl"), "signUpUrl", context, [])), env.opts.autoescape);
output += "\" rel=\"nofollow\" data-cm-element=\"account_create_modal\" class=\"c-modal-login__a js-user-create\" data-qa-user-create>\n        ";
output += runtime.suppressValue((lineno = 11, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_create-account-heading",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n\n</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/forgot-password/signin-signup.j2"] , dependencies)